import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NavAppTitleResolver implements Resolve<string> {
  constructor(private title: Title) {}
  resolve(route: ActivatedRouteSnapshot): string {
    const navAppName = route.params['name'];
    const fullTitle = `Web Component: ${navAppName}`;
    this.title.setTitle(fullTitle);
    return fullTitle;
  }
}

// Need to add another level of title after 'nav app > XXX'
